import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const CheckboxUncheckedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 15 15" fill="none"  >
    <path d="M12 1C12 0.4 11.6 0 11 0H1C0.4 0 0 0.4 0 1V11C0 11.6 0.4 12 1 12H11C11.6 12 12 11.6 12 11V1ZM10.3 10.3H1.7V1.7H10.3V10.3ZM15 6V14C15 14.6 14.6 15 14 15H6C5.4 15 5 14.6 5 14V13H13V5H14C14.6 5 15 5.4 15 6Z" fill="#2B3940"/>
  </SvgIcon>
);
CheckboxUncheckedIcon.displayName = "CheckboxChecked";
CheckboxUncheckedIcon.muiName = "SvgIcon";

export default pure(CheckboxUncheckedIcon);